// Copyright 2016 Sorama B.V.

/*
 * Adapted from: https://gist.run/?id=d9d8dd9df7be2dd2f59077bad3bfb399
 * as mentioned in: https://github.com/aurelia/binding/issues/443#issuecomment-232007548
 */
import { BindingEngine, bindingMode, customAttribute, Disposable, DOM, inject } from "aurelia-framework";
import { Size } from "libraries/DataTypes/Size";

@customAttribute("resizable", bindingMode.twoWay)
@inject(DOM.Element, BindingEngine)
export class Resizable {
    //#region Constants
    public static resizedEventName = "resized";
    //#endregion

    private element: HTMLElement;
    private bindingEngine: BindingEngine;

    private widthSubscription: Disposable;
    private heightSubscription: Disposable;

    constructor(element: HTMLInputElement, bindingEngine: BindingEngine) {
        this.element = element;
        this.bindingEngine = bindingEngine;
    }

    private bind() {
        this.widthSubscription = this.bindingEngine
            .propertyObserver(this.element, "clientWidth")
            .subscribe(this.elementWidthChanged);
        this.heightSubscription = this.bindingEngine
            .propertyObserver(this.element, "clientHeight")
            .subscribe(this.elementHeightChanged);
    }

    private unbind() {
        this.widthSubscription.dispose();
        this.heightSubscription.dispose();
    }

    private elementWidthChanged = (newValue: number, oldValue: number) => {
        const newClientSize = <Size>{
            width: newValue,
            height: this.element.clientHeight,
        };

        const oldClientSize = <Size>{
            width: oldValue,
            height: this.element.clientHeight,
        };

        this.elementSizeChanged(newClientSize, oldClientSize);
    };

    private elementHeightChanged = (newValue: number, oldValue: number) => {
        const newClientSize = <Size>{
            width: this.element.clientWidth,
            height: newValue,
        };

        const oldClientSize = <Size>{
            width: this.element.clientWidth,
            height: oldValue,
        };

        this.elementSizeChanged(newClientSize, oldClientSize);
    };

    private elementSizeChanged(newClientSize: Size, oldClientSize: Size): void {
        const sizeChangedEvent = new CustomEvent(Resizable.resizedEventName, <CustomEventInit>{
            detail: {
                newValue: newClientSize,
                oldValue: oldClientSize,
            },
            bubbles: true,
        });

        this.element.dispatchEvent(sizeChangedEvent);
    }
}
